(function () {
  'use strict';
  var root = document.querySelector('[data-ss-consent]');
  if (!root) return;
  var banner = root.querySelector('.ss-consent__banner');
  var preferences = root.querySelector('.ss-consent__preferences');
  var manage = root.querySelector('.ss-consent__manage');
  var analytics = root.querySelector('[data-consent-option="analytics"]');
  var marketing = root.querySelector('[data-consent-option="marketing"]');
  var lastFocused = null;
  var params = new URLSearchParams(window.location.search);
  var previewRequested = params.get('ss_cookie_preview') === '1';
  var forcePreview = previewRequested;

  function suppressNativeInterface() {
    root.classList.toggle('ss-consent--preview-bar', Boolean(document.querySelector('#PBarNextFrame')));
    document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, .shopify-pc__banner__dialog, .shopify-pc__prefs__dialog').forEach(function (element) {
      element.hidden = true;
      element.setAttribute('aria-hidden', 'true');
    });
  }
  suppressNativeInterface();
  new MutationObserver(suppressNativeInterface).observe(document.documentElement, { childList: true, subtree: true });

  function consentApi() { return window.Shopify && window.Shopify.customerPrivacy; }
  function withConsentApi(callback, attempt) {
    attempt = attempt || 0;
    if (consentApi()) { callback(consentApi()); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
        if (consentApi()) callback(consentApi());
      });
      return;
    }
    if (attempt < 40) window.setTimeout(function () { withConsentApi(callback, attempt + 1); }, 125);
  }
  function isAnswered(value) { return value === true || value === false || value === 'yes' || value === 'no'; }
  function isAllowed(value) { return value === true || value === 'yes'; }
  function currentConsent(api) {
    try { return api.currentVisitorConsent ? api.currentVisitorConsent() : {}; } catch (error) { return {}; }
  }
  function hasDecision(consent) { return isAnswered(consent.analytics) && isAnswered(consent.marketing) && isAnswered(consent.preferences); }

  function showBanner() {
    root.hidden = false; banner.hidden = false; preferences.hidden = true; manage.hidden = true;
    root.dataset.consentState = 'pending';
    window.requestAnimationFrame(function () { var first = banner.querySelector('button'); if (first) first.focus({ preventScroll: true }); });
  }
  function showManage() { root.hidden = false; banner.hidden = true; preferences.hidden = true; manage.hidden = false; }
  function showPreferences() {
    lastFocused = document.activeElement;
    withConsentApi(function (api) {
      var consent = currentConsent(api);
      analytics.checked = isAllowed(consent.analytics); marketing.checked = isAllowed(consent.marketing);
    });
    root.hidden = false; banner.hidden = true; preferences.hidden = false; manage.hidden = true;
    window.requestAnimationFrame(function () { var close = preferences.querySelector('[data-consent-action="close"]'); if (close) close.focus({ preventScroll: true }); });
  }
  function closePreferences() {
    preferences.hidden = true; showManage();
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
  }
  function saveConsent(values, state) {
    withConsentApi(function (api) {
      api.setTrackingConsent(values, function (error) {
        if (error) {
          root.dataset.consentState = 'error';
          return;
        }
        var saved = currentConsent(api);
        root.dataset.consentAnalytics = saved.analytics || '';
        root.dataset.consentMarketing = saved.marketing || '';
        root.dataset.consentPreferences = saved.preferences || '';
        root.dataset.consentState = state; showManage();
        var status = root.querySelector('.ss-consent__status'); if (status) status.textContent = status.textContent + ' ';
      });
    });
  }

  root.addEventListener('click', function (event) {
    var target = event.target.closest('[data-consent-action]'); if (!target) return;
    switch (target.dataset.consentAction) {
      case 'accept': saveConsent({ analytics: true, marketing: true, preferences: true }, 'accepted'); break;
      case 'reject': saveConsent({ analytics: false, marketing: false, preferences: false }, 'rejected'); break;
      case 'choose': case 'manage': showPreferences(); break;
      case 'close': closePreferences(); break;
      case 'save': saveConsent({ analytics: analytics.checked, marketing: marketing.checked, preferences: true }, 'custom'); break;
    }
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#shopifyReshowConsentBanner"]');
    if (!link) return;
    event.preventDefault();
    showPreferences();
  });

  document.addEventListener('keydown', function (event) {
    if (preferences.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); closePreferences(); return; }
    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(preferences.querySelectorAll('button, input:not([disabled]), a[href]'), function (element) { return !element.hidden && element.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0]; var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  withConsentApi(function (api) {
    var consent = currentConsent(api); var shouldShow = false;
    try { shouldShow = typeof api.shouldShowBanner === 'function' && api.shouldShowBanner(); } catch (error) { shouldShow = !hasDecision(consent); }
    if (forcePreview || shouldShow || !hasDecision(consent)) showBanner();
    else { root.dataset.consentState = 'saved'; showManage(); }
  });
})();
